import { StarsButton as Button, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import type { Dispatch } from '@swf/core/store';

import useLogoutUser from '../hooks/useLogoutUser';

import {
  TXTCLI_Cancel,
  TXTWCL_I_do_want_to_continue_receivin_ELL,
  TXTWCL_I_understand_I_can_change_this_ELL,
  TXTWCL_OopsX_I_need_to_change_my_comm_ELL,
  TXTWCL_Opt_In,
  TXTWCL_Thank_you_for_accepting_our_ne_ELL
} from './LoginEulaOptin.messages.json';
import styles from './LoginEulaOptin.scss';

const LoginEulaOptin: React.FC = () => {
  const logout = useLogoutUser();

  const {
    auth: { signEula }
  } = useDispatch<Dispatch>();

  const handleSignEula = async (marketingMailList: boolean) => {
    await signEula({ marketingMailList });
    logout();
  };

  return (
    <>
      <p>
        <Translation {...TXTWCL_OopsX_I_need_to_change_my_comm_ELL} />{' '}
        <Translation {...TXTWCL_I_do_want_to_continue_receivin_ELL} />{' '}
        <Translation {...TXTWCL_I_understand_I_can_change_this_ELL} />
      </p>
      <ButtonGroup inline className={styles.buttons}>
        <Button
          className={styles.button}
          onClick={() => handleSignEula(true)}
          translation={TXTWCL_Opt_In}
        />
        <Button
          className={styles.button}
          variant="secondary"
          onClick={() => handleSignEula(false)}
          translation={TXTCLI_Cancel}
        />
      </ButtonGroup>
      <Translation tagName="p" {...TXTWCL_Thank_you_for_accepting_our_ne_ELL} />
    </>
  );
};

export default LoginEulaOptin;
